import React from 'react';

const URL_PATTERN =
  /\b((?:https?:\/\/|www\.)[^\s<]+|(?:[a-z0-9-]+\.)+[a-z]{2,})(?=[\s<.,;:!?)]|$)/gi;

export function parseLinks(text: string): React.ReactNode[] {
  if (!text) return [];

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  text.replace(URL_PATTERN, (match, url, offset) => {
    // Push text before the match
    if (lastIndex < offset) {
      parts.push(text.slice(lastIndex, offset));
    }

    // Strip trailing punctuation from URL
    let cleanUrl = match.replace(/[),.;:!?]+$/, '');
    let trailing = match.slice(cleanUrl.length); // save trailing punctuation

    const href = cleanUrl.startsWith('http') ? cleanUrl : `https://${cleanUrl}`;

    parts.push(
      <a
        key={`link-${offset}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-gold-400 hover:text-gold-500 hover:underline break-words"
        onClick={(e) => e.stopPropagation()}
      >
        {cleanUrl}
      </a>
    );

    // Add any trailing punctuation
    if (trailing) {
      parts.push(trailing);
    }

    lastIndex = offset + match.length;
    return match;
  });

  // Push any remaining text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
}
